import {apiUrl, httpClient} from "../../api.js";

export const getCourierAvailability = async({userId, start, productId}) => {
  const params = new URLSearchParams();

  if(start){
    params.append('start', start);
  }

  if(productId){
    params.append('product_id', productId);
  }

  const queryString = params.toString();
  const response = await httpClient.get(`${apiUrl}/courier/${userId}/availability?${queryString}`)
  return response.data
}


export const getCourierOrders = async ({
                                         shiftId,
                                         startCreatedAt,
                                         endCreatedAt,
                                         productId,
                                         courierId,
                                         operatorId,
                                         shopId
                                       }) => {
  try {
    const params = new URLSearchParams();

    if (shiftId) params.append('shift_id', shiftId);
    if (shopId) params.append('shop_id', shopId);
    if (operatorId) params.append('operator_id', operatorId);
    if (startCreatedAt) params.append('start_created_at', startCreatedAt);
    if (endCreatedAt) params.append('end_created_at', endCreatedAt);
    if (productId) params.append('product_id', productId);
    if (courierId) params.append('courier_id', courierId);

    const response = await httpClient.get(`${apiUrl}/courier-orders`, {
      params,
    });

    const formatted = response.data.map(order => ({
      ...order,
      deliveryPrice: order.delivery_price,
      paymentMethod: order.payment_method,
      shiftId: order.shift_id,
      courierId: order.courier_id,
    }));

    return formatted;
  } catch (error) {
    console.error('Failed to fetch courier orders:', error);
    return [];
  }
};

export const getStoremanOrders = async ({
                                          limit = 10,
                                          offset = 0,
                                          operatorId = null,
                                          start = null,
                                          end = null,
                                          returnCancelled = null,
                                          returnSent = null,
                                          returnCreated = null,
                                          courierId = null,
                                          productId = null,
                                          shopId = null,
                                          startSentAt = null,
                                          endSentAt = null,
                                          commentQuery = "",
                                          storemanId = null,
                                        }) => {
  try {
    const params = new URLSearchParams({
      limit,
      offset,
    });

    if (operatorId) params.append('operator_id', operatorId);
    if (shopId) params.append('shop_id', shopId);
    if (start) params.append('start_created_at', start);
    if (end) params.append('end_created_at', end);
    if (startSentAt) params.append('start_sent_at', startSentAt);
    if (endSentAt) params.append('end_sent_at', endSentAt);
    if (returnCancelled !== null) params.append('cancelled_at', returnCancelled);
    if (returnSent !== null) params.append('sent_at', returnSent);
    if (returnCreated !== null) params.append('created_at', returnCreated);
    if (courierId) params.append('recipient_user_id', courierId);
    if (productId) params.append('product_id', productId);
    if (commentQuery) params.append('comment_query', commentQuery);
    if (storemanId) params.append('storeman_id', storemanId);

    const response = await httpClient.get(`${apiUrl}/storeman-orders`, {
      params,
    });

    return response.data;
  } catch (error) {
    console.error('Failed to fetch storeman orders:', error);
    return [];
  }
};

export const getProductMovements = async ({ userId, limit = 10, offset = 0 }) => {
  try {
    const params = new URLSearchParams({
      limit,
      offset,
    });

    const response = await httpClient.get(`${apiUrl}/courier/${userId}/product-movements`, {
      params,
    });

    return response.data;
  } catch (error) {
    console.error('Failed to fetch product movements:', error);
    return [];
  }
};

